import React from "react";
import { Link } from "react-router";
import { Table, Tr, Td } from "reactable";
import { Status } from "./film-table.jsx";

class FilmTable extends React.Component {
  constructor(props) {
    super(props);
    this._makeRowForEvent = this._makeRowForEvent.bind(this);
  }

  getStyles() {
    return {};
  }

  _makeRowForEvent(virtualContent) {
    return (
      <Tr key={virtualContent.id}>
        <Td column="Label">{virtualContent.label}</Td>
        <Td column="Status">
          <Status virtual_content={virtualContent} detailed={false} />
        </Td>
        <Td column="Actions">
          <div>
            <Link
              to={{
                pathname: `/creator_hub/virtual_content/${virtualContent.id}`,
                state: { fromListing: true }
              }}
            >
              Manage asset
            </Link>
          </div>
        </Td>
      </Tr>
    );
  }

  render() {
    let styles = this.getStyles(),
      { virtualContent } = this.props;

    const tableProps = {
      className: "bordered striped responsive-table",
      sortable: ["Label", "Status"],
      defaultSort: { column: "Label", direction: "asc" },
      columns: ["Label", "Status", "Actions"],
      filterable: ["Label", "Status"]
    };

    return (
      <div>
        <style>{`
          .reactable-filterer input {
            width: 200px;
          }
        `}</style>
        <div>
          <Table
            {...tableProps}
            filterPlaceholder={"Type to filter content assets..."}
          >
            {virtualContent.map(v => this._makeRowForEvent(v))}
          </Table>
        </div>
      </div>
    );
  }
}

export default FilmTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/virtual-content-table.jsx